import "./wasm_exec";
import { Elm } from "./Main.elm";

const go = new Go();
WebAssembly.instantiateStreaming(fetch("main.wasm"), go.importObject)
	.then((result) => {
		go.run(result.instance);
	})
	.then(() => {
		const elmNode = document.getElementById("elm");
		const app = Elm.Main.init({ node: elmNode });

		app.ports.assessApplication.subscribe((msg: string) => {
			const { application, config } = JSON.parse(msg);
			console.log("APP", application);
			console.log("CONFIG", config);
			window
				.assessApplication(config, application)
				.then((r) => app.ports.receiveAssessment.send(JSON.stringify(r)))
				.catch((e) => console.error(e));
		});
	});
